"use strict";
// --------------------------------------------------------------------------------------------------------------------
// <copyright file="Contact.ts" company="Microsoft">
//   Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// <summary>
//   TypeScript implementation of the HxContact object
//   THIS FILE IS GENERATED BY A TOOL -- OBJECTGEN, DO NOT EDIT BY HAND
// </summary>
// --------------------------------------------------------------------------------------------------------------------
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HxContact = void 0;
var HxObject_1 = __importDefault(require("./HxObject"));
var HxObjectID_1 = __importDefault(require("./HxObjectID"));
var HxObjectType_1 = __importDefault(require("./HxObjectType"));
var HxContactEmail_1 = require("./HxContactEmail");
var HxContact = /** @class */ (function (_super) {
    __extends(HxContact, _super);
    function HxContact(objectId, storageSequenceNumber, obj, activeSet) {
        var _this = _super.call(this, objectId, HxObjectType_1.default.HxContact, storageSequenceNumber, activeSet) || this;
        _this.update(obj);
        return _this;
    }
    HxContact.prototype.update = function (obj) {
        var e_1, _a;
        try {
            for (var _b = __values(Object.entries(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), key = _d[0], v = _d[1];
                switch (key) {
                    case '1':
                        this.objectId = new HxObjectID_1.default(v);
                        break;
                    case '2':
                        this.parentId = new HxObjectID_1.default(v);
                        break;
                    case '63D':
                        this.accountId = new HxObjectID_1.default(v);
                        break;
                    case '5D7':
                        this.addressesId = new HxObjectID_1.default(v);
                        break;
                    case '1346':
                        this.age = v;
                        break;
                    case 'AD9':
                        this.assistantName = v;
                        break;
                    case '1347':
                        this.astrologySign = v;
                        break;
                    case '1348':
                        this.bloodType = v;
                        break;
                    case '701':
                        this.businessHomePage = v;
                        break;
                    case '122B':
                        this.canDelete = v;
                        break;
                    case '122C':
                        this.canModify = v;
                        break;
                    case '12F0':
                        var categoriesValues = v;
                        this.categories = new Array(categoriesValues.length);
                        for (var i = 0; i < categoriesValues.length; i++) {
                            this.categories[i] = categoriesValues[i];
                        }
                        break;
                    case '13FC':
                        this.certificatesId = new HxObjectID_1.default(v);
                        break;
                    case '602':
                        this.changeKey = Buffer.from(v, 'base64');
                        break;
                    case '152E':
                        this.contactUpToDate = v;
                        break;
                    case '63C':
                        this.deviceId = v;
                        break;
                    case '5D8':
                        this.displayName = v;
                        break;
                    case '5DA':
                        this.displayNamePrefix = v;
                        break;
                    case '5DB':
                        this.displayNameSuffix = v;
                        break;
                    case '5D9':
                        var emailsValues = v;
                        this.emails = new Array(emailsValues.length);
                        for (var i = 0; i < emailsValues.length; i++) {
                            this.emails[i] = HxContactEmail_1.deserializeHxContactEmail(emailsValues[i]);
                        }
                        break;
                    case 'B34':
                        this.exchangeObjectId = v;
                        break;
                    case '133C':
                        this.firstLastDisplayName = v;
                        break;
                    case '5DC':
                        this.firstName = v;
                        break;
                    case 'B35':
                        this.graphId = v;
                        break;
                    case 'B36':
                        this.hasRemoteId = v;
                        break;
                    case 'ADA':
                        this.imAddressesId = new HxObjectID_1.default(v);
                        break;
                    case '5E0':
                        this.importantDatesId = new HxObjectID_1.default(v);
                        break;
                    case '1349':
                        this.interests = v;
                        break;
                    case '1368':
                        this.isFavorite = v;
                        break;
                    case 'E60':
                        this.isGalContact = v;
                        break;
                    case '12F1':
                        this.isPrivate = v;
                        break;
                    case '5E1':
                        this.jobInfoCompanyName = v;
                        break;
                    case '5E2':
                        this.jobInfoCompanyYomiName = v;
                        break;
                    case '5E3':
                        this.jobInfoDepartment = v;
                        break;
                    case '5E4':
                        this.jobInfoManager = v;
                        break;
                    case '5E5':
                        this.jobInfoOfficeLocation = v;
                        break;
                    case '5E6':
                        this.jobInfoTitle = v;
                        break;
                    case '133E':
                        this.lastFirstDisplayName = v;
                        break;
                    case 'DBA':
                        this.lastModifiedTime = new Date(v);
                        break;
                    case '5DD':
                        this.middleName = v;
                        break;
                    case '5DF':
                        this.nickname = v;
                        break;
                    case '5E7':
                        this.notes = v;
                        break;
                    case 'DC8':
                        this.notesTooBig = v;
                        break;
                    case '152F':
                        this.ownedBySearch = v;
                        break;
                    case '702':
                        this.personalHomePage = v;
                        break;
                    case '5E8':
                        this.phonesId = new HxObjectID_1.default(v);
                        break;
                    case '70B':
                        this.photo = v;
                        break;
                    case 'D4C':
                        this.photoKind = v;
                        break;
                    case '70C':
                        this.photoServerId = v;
                        break;
                    case 'D3A':
                        this.photoType = v;
                        break;
                    case 'D3B':
                        this.photoUri = v;
                        break;
                    case '1570':
                        this.photoUrl = v;
                        break;
                    case '13F2':
                        this.searchDataId = new HxObjectID_1.default(v);
                        break;
                    case '601':
                        this.serverId = v;
                        break;
                    case '5E9':
                        this.significantOthersId = new HxObjectID_1.default(v);
                        break;
                    case '5DE':
                        this.surname = v;
                        break;
                    case 'D63':
                        this.unused = v;
                        break;
                    case '704':
                        this.urlsId = new HxObjectID_1.default(v);
                        break;
                    case '603':
                        this.yomiGivenName = v;
                        break;
                    case '5EB':
                        this.yomiNickname = v;
                        break;
                    case '5EC':
                        this.yomiSurname = v;
                        break;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    HxContact.prototype.getAccount = function (sessionId) {
        return this.activeSet.getObject(this.accountId, sessionId).then(function (result) { return result; });
    };
    HxContact.prototype.getAddresses = function (sessionId) {
        return this.activeSet.getCollection(this.addressesId, sessionId);
    };
    HxContact.prototype.getCertificates = function (sessionId) {
        return this.activeSet.getCollection(this.certificatesId, sessionId);
    };
    HxContact.prototype.getImAddresses = function (sessionId) {
        return this.activeSet.getCollection(this.imAddressesId, sessionId);
    };
    HxContact.prototype.getImportantDates = function (sessionId) {
        return this.activeSet.getCollection(this.importantDatesId, sessionId);
    };
    HxContact.prototype.getPhones = function (sessionId) {
        return this.activeSet.getCollection(this.phonesId, sessionId);
    };
    HxContact.prototype.getSearchData = function (sessionId) {
        return this.activeSet.getCollection(this.searchDataId, sessionId);
    };
    HxContact.prototype.getSignificantOthers = function (sessionId) {
        return this.activeSet.getCollection(this.significantOthersId, sessionId);
    };
    HxContact.prototype.getUrls = function (sessionId) {
        return this.activeSet.getCollection(this.urlsId, sessionId);
    };
    return HxContact;
}(HxObject_1.default));
exports.HxContact = HxContact;
exports.default = HxContact;
